var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-tabs", class: { "v-tabs_alternate": _vm.alternate } },
    [
      _c("nav", { staticClass: "v-tabs__header" }, [
        _c(
          "ul",
          { staticClass: "v-tabs__list" },
          _vm._l(_vm.tabs, function(tab, index) {
            return _c(
              "li",
              {
                staticClass: "v-tabs__item",
                class: {
                  "v-tabs__item--is-selected": _vm.selectedTabIndex === index
                },
                on: {
                  click: function($event) {
                    return _vm.selectTab(index)
                  }
                }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "v-tabs__button",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [_vm._v("\n     " + _vm._s(tab[_vm.nameBy]) + "\n    ")]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { isOpen: true } },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _vm._t("documents-header", function() {
                return [_vm._v(_vm._s(_vm.documentsHeader))]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "v-tabs__body-holder",
              class: {
                "v-tabs__body-holder_tabs-not-activated": _vm.tabsNotActivated
              }
            },
            [
              _vm.fetching
                ? _c("p", [_vm._v("Fetching data...")])
                : _vm._t("documents")
            ],
            2
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { isOpen: true } },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _vm._t("documents-header", function() {
                return [_vm._v(_vm._s(_vm.extraInformationHeader))]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "v-tabs__body-holder",
              class: {
                "v-tabs__body-holder_tabs-not-activated": _vm.tabsNotActivated
              }
            },
            [
              _vm.fetching
                ? _c("p", [_vm._v("Fetching data...")])
                : _vm._t("extrainfo")
            ],
            2
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { isOpen: true } },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _vm._t("documents-header", function() {
                return [_vm._v(_vm._s(_vm.signedDocumentsHeader))]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "v-tabs__body-holder",
              class: {
                "v-tabs__body-holder_tabs-not-activated": _vm.tabsNotActivated
              }
            },
            [
              _vm.fetching
                ? _c("p", [_vm._v("Fetching data...")])
                : _vm._t("attachments")
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce1aa1e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce1aa1e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VMembersTabs.vue
// module id = 264
// module chunks = 1 2